module.exports = __webpack_public_path__ + "img/7_5.339dd73d.png";